// Centralize all process.env in this class. It helps us manage and know what env vars we are using currently.
import locator from '@/service-locator'

class Config {
  env = process.env.VUE_APP_ENV

  isDev = process.env.VUE_APP_ENV === 'development'

  isProduction = process.env.VUE_APP_ENV === 'production'

  isStaging = process.env.VUE_APP_ENV === 'staging'

  isSandbox = process.env.VUE_APP_ENV === 'sandbox'

  releaseVersion = process.env.VUE_APP_RELEASE_VERSION || 'unknown'

  zendeskKey = process.env.VUE_APP_ZENDESK_KEY || ''

  zendeskMetaBotLocaleMobileWeb =
    process.env.VUE_APP_ZENDESK_META_BOT_LOCALE || ''

  zendeskMetaContactPlatform =
    process.env.VUE_APP_ZENDESK_META_CONTACT_PLATFORM || ''

  zendeskMetaMerchantAuthenticatedStatus =
    process.env.VUE_APP_ZENDESK_META_MERCHANT_AUTHENTICATED_STATUS || ''

  zendeskMetaMerchantName = process.env.VUE_APP_ZENDESK_META_MERCHANT_NAME || ''

  zendeskMetaMerchantTier = process.env.VUE_APP_ZENDESK_META_MERCHANT_TIER || ''

  zendeskMetaMerchantEmail =
    process.env.VUE_APP_ZENDESK_META_MERCHANT_EMAIL || ''

  zendeskMetaMerchantId = process.env.VUE_APP_ZENDESK_META_MERCHANT_ID || ''

  zendeskMetaMerchantCode = process.env.VUE_APP_ZENDESK_META_MERCHANT_CODE || ''

  zendeskMetaMerchantUserId =
    process.env.VUE_APP_ZENDESK_META_MERCHANT_USER_ID || ''

  zendeskMetaMerchantUserEmail =
    process.env.VUE_APP_ZENDESK_META_MERCHANT_USER_EMAIL || ''

  zendeskMetaMerchantUserName =
    process.env.VUE_APP_ZENDESK_META_MERCHANT_USER_NAME || ''

  newZendeskKey = process.env.VUE_APP_NEW_ZENDESK_KEY || ''

  newZendeskMetaBotLocaleMobileWeb =
    process.env.VUE_APP_NEW_ZENDESK_META_BOT_LOCALE || ''

  newZendeskMetaContactPlatform =
    process.env.VUE_APP_NEW_ZENDESK_META_CONTACT_PLATFORM || ''

  newZendeskMetaMerchantAuthenticatedStatus =
    process.env.VUE_APP_NEW_ZENDESK_META_MERCHANT_AUTHENTICATED_STATUS || ''

  newZendeskMetaMerchantId =
    process.env.VUE_APP_NEW_ZENDESK_META_MERCHANT_ID || ''

  newZendeskMetaMerchantUserId =
    process.env.VUE_APP_NEW_ZENDESK_META_MERCHANT_USER_ID || ''

  newZendeskMetaMerchantUserEmail =
    process.env.VUE_APP_NEW_ZENDESK_META_MERCHANT_USER_EMAIL || ''

  newZendeskMetaMerchantUserName =
    process.env.VUE_APP_NEW_ZENDESK_META_MERCHANT_USER_NAME || ''

  zendeskContactPlatformValue =
    process.env.VUE_APP_ZENDESK_CONTACT_PLATFORM_VALUE ||
    'tamara_partners_portal_web'

  apiJerk = process.env.VUE_APP_JERK_API || ''

  defaultChatbotService = process.env.VUE_APP_DEFAULT_CHATBOT_SERVICE || ''

  isEnabledAdtechAds = [
    'production',
    'staging',
    'local',
    'dev5',
    'sandbox',
  ].includes(process.env.VUE_APP_ENV)

  guidesailKey = ''

  onboardingPageUrl = process.env.VUE_APP_ONBOARDING_PAGE_URL || ''

  googleMapsApiKey = process.env.VUE_APP_GOOGLE_MAPS_API_KEY || ''

  statsigKey = process.env.VUE_APP_STATSIG_CLIENT_KEY || ''

  isEnabledFarahPromotionReview =
    process.env.VUE_APP_ADTECH_PROMOTION_REVIEW === 'true'

  isEnabledDealsBilling = process.env.VUE_APP_ADTECH_DEALS_BILLING === 'true'

  partnerPageUrl = process.env.VUE_APP_PARTNER_PAGE_URL || ''

  gaMeasurementId = process.env.VUE_APP_GA4_ID || ''

  googleAdsId = process.env.VUE_APP_GOOGLE_ADS_ID || ''

  rudderStackWriteKey = process.env.VUE_APP_RUDDERSTACK_WRITE_KEY || ''

  rudderStackDataPlaneUrl = process.env.VUE_APP_RUDDERSTACK_DATA_PLANE_URL || ''

  newMerchantPortalBaseUrl = process.env.VUE_APP_MERCHANT_PORTAL_BASE_URL || ''

  // Salesforce Embedded Messaging configuration
  salesforceOrgId = process.env.VUE_APP_SALESFORCE_ORG_ID || ''

  salesforceDeploymentId = process.env.VUE_APP_SALESFORCE_DEPLOYMENT_ID || ''

  salesforceUnauthenticatedDeploymentId =
    process.env.VUE_APP_SALESFORCE_UNAUTHENTICATED_DEPLOYMENT_ID || ''

  salesforceServiceEndpoint =
    process.env.VUE_APP_SALESFORCE_SERVICE_ENDPOINT || ''

  salesforceEmbeddedServiceUrl =
    process.env.VUE_APP_SALESFORCE_EMBEDDED_SERVICE_URL || ''

  salesforceUnauthenticatedServiceEndpoint =
    process.env.VUE_APP_SALESFORCE_UNAUTHENTICATED_SERVICE_ENDPOINT || ''

  salesforceUnauthenticatedEmbeddedServiceUrl =
    process.env.VUE_APP_SALESFORCE_UNAUTHENTICATED_EMBEDDED_SERVICE_URL || ''

  salesforceScrt2Url = process.env.VUE_APP_SALESFORCE_SCRT2_URL || ''

  salesforcePartnerChanel = process.env.VUE_APP_SALESFORCE_PARTNER_CHANNEL || ''

  apiBaseUrl = process.env.VUE_APP_API_BASE_URL || ''
}

locator.config = new Config()

export default locator.config
